import type { CommonContent } from "../types";

export const common: CommonContent = {
  brand: "Padangos-Andze1",
  brandTagline: "Padangų servisas Naujojoje Vilnioje",
  navHome: "Pradžia",
  navUsedTires: "Naudotos Padangos",
  navMontavimas: "Montavimas ir Remontas",
  navRatlankiai: "Ratlankių Lyginimas",
  heroTitle: "Padangų pardavimas ir montavimas Naujojoje Vilnioje",
  heroSubtitle: "Geriausiomis Kainomis",
  footerCopyright: "Padangos-Andze1 · A. Semaško I.Į.",
  footerContacts: "Kontaktai",
  footerLinks: "Nuorodos",
};
